import React from "react";
import Embed from "semantic-ui-react/dist/commonjs/modules/Embed";
import { Link } from "../../lib/Link";

export const confirmation_matters = ( type, asset ) => {
  return (
    <div className="confirmation_matters">
      <div className="infomation">
        <div className="title">ご契約前にご確認ください</div>
        <div className="collections">
          <Link to="/flow/" className="item">
            ご契約の流れ<br/>
            最短3分! WEB・電話でのお申込み
          </Link>
          <Link to="/service/" className="item">
            運搬・各種オプション<br/>
            安心保証パックなどのご紹介
          </Link>
          <Link to="/voice2/" className="item">
            お客様の声<br/>
            トランクルーム選びの参考に
          </Link>
        </div>
      </div>
      <div className="movies insizde">
        {(() => {
          if (asset.assetType !== 'bikeonly' && asset.bike !== 1) {
            return (
              <Embed id={asset.youtube} source="youtube" autoplay={false} defaultActive={true} />
            );
          }
        })()}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/detail/confirmation_matters.jsx